import React, {Component} from 'react'
import OrdersContainer from './orders/OrdersContainer'

class HomePage extends Component {
    render() {
        return (
            <div className='HomePage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm'>
                        <OrdersContainer {...this.props}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default HomePage
